import { v4 as uuidv4 } from 'uuid';

export function ContenderMedia(){
    this.id = uuidv4();
    this.fileName = null;
    this.originalFileName = null;
    this.contenderId = null;
    this.previewImageUrl = null;
    this.status = null;
    this.ordinal = null;
    this.description = null;
}